import { render, staticRenderFns } from "./InvInView.vue?vue&type=template&id=516af736&scoped=true&"
import script from "./InvInView.vue?vue&type=script&lang=js&"
export * from "./InvInView.vue?vue&type=script&lang=js&"
import style0 from "./InvInView.vue?vue&type=style&index=0&id=516af736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516af736",
  null
  
)

export default component.exports